import React from 'react';

import { dateRangeLPO } from '../../helpers/dates';
import { LeisurePackageOfferCard } from '../../helpers/list-page/interfaces/list-card.interface';
import { ILibraryMeetingPlaceDictionary } from '@/lib/fragments/libraryMeetingPlaceDictionary';
// import { FavouriteButton } from '../ui/favourite-button/favourite-button'; // TODO: re-enable when LPO favourites are needed
import Link from 'next/link';

interface CardLeisurePackageOfferProps {
  card: LeisurePackageOfferCard;
  cardIndex: number;
  dictionary?: ILibraryMeetingPlaceDictionary;
}

export const CardLeisurePackageOffer = ({
  card,
  cardIndex,
  dictionary,
}: CardLeisurePackageOfferProps) => {
  const getCurrency = (card: LeisurePackageOfferCard) => {
    const { salesPrice, originalPrice, currency } = card;
    if (salesPrice && originalPrice) {
      return (
        <p className="text-headingm text-text-default">
          {salesPrice && (
            <span className="mr-2 text-bodyl text-text-light line-through decoration-text-light decoration-2">
              {currency} {originalPrice}
            </span>
          )}
          {currency} {salesPrice === '0' ? dictionary?.free : salesPrice}
        </p>
      );
    } else if (salesPrice === '0') {
      return (
        <p className="text-headingm text-text-default">
          {currency} {dictionary?.free}
        </p>
      );
    } else {
      return (
        <p className="text-headingm text-text-default">
          {currency} {salesPrice}
        </p>
      );
    }
  };

  return (
    // TODO: re-enable wrapper div + FavouriteButton when LPO favourites are needed
    // <div className="relative">
    <Link
      href={card.slug}
      className={`flex cursor-pointer flex-col rounded-xl bg-background-primary-light p-6 transition-all duration-200 lg:hover:bg-background-secondary focus:outline focus:outline-3 focus:outline-offset-3 focus:outline-text-light`}
    >
      {card?.image?.url ? (
        <div className="image-box relative rounded-xl overflow-hidden bg-background-primary-light transition-all lg:hover:bg-background-secondary">
          {/* Blurred background */}
          <img
            src={card.image.url}
            alt={card.image.alt || 'alt text not found'}
            aria-hidden="true"
            className="absolute inset-0 h-full w-full object-cover scale-110 will-change-transform pointer-events-none"
            style={{ filter: 'blur(10px) brightness(0.8)' }}
          />

          {/* contained image on top  */}
          <img
            src={card.image.url}
            alt={card.image.alt || 'alt text not found'}
            className="absolute inset-0 h-full w-full object-contain"
            loading="lazy"
            decoding="async"
          />
        </div>
      ) : (
        <div className="flex-grow"></div>
      )}
      <div className="flex min-h-[9rem] flex-1 flex-col flex-wrap rounded-b-xl">
        <div className="mt-4 font-title text-headingxs font-bold text-text-light">
          {card?.cardTag && card.cardTag}
        </div>
        <div className="mt-2 line-clamp-2 max-h-[56px] overflow-hidden text-ellipsis font-title text-headingm font-bold">
          {card?.titleLeisurePackageOffer}
        </div>
        {(card?.offerValidFrom?.isValid || card?.offerValidTill?.isValid) && (
          <div className="mt-1 line-clamp-1 h-[24px] overflow-hidden text-ellipsis break-all text-bodym text-text-light">
            {dateRangeLPO(
              card?.offerValidFrom?.toString() || '',
              card?.offerValidTill?.toString() || '',
              card.node_locale,
              dictionary?.from,
              dictionary?.until,
            )}
          </div>
        )}
        <div className="flex flex-wrap gap-2 mt-1">
          {card?.lpoTags &&
            card?.lpoTags?.filter(Boolean)?.map((tag, key) => (
              <span
                key={key}
                className="flex-shrink-0 rounded-[4px] border-2 border-neutral-grey-200 bg-background-primary-light px-2 text-bodyxs font-bold text-text-default"
              >
                {tag?.name}
              </span>
            ))}
        </div>
        <div className="mt-4 flex flex-grow items-end justify-between">
          {getCurrency(card)}
        </div>
      </div>
    </Link>
    // <FavouriteButton id={card.id} type="leisurePackageOffer" className="absolute top-3 right-3 z-10" />
    // </div>
  );
};
